import { FormControl } from "@itandi/itandi-bb-ui/FormControl";
import { Input } from "@itandi/itandi-bb-ui/Input";
import { InputDatev2 } from "@itandi/itandi-bb-ui/InputDatev2";
import type React from "react";
import { useFormContext } from "react-hook-form";
import type { DealInspectionCandidateDateParam } from "~/models/InspectionCandidateDate";
import { formatDate, toDate } from "~/utils/DateUtil";
import Styles from "./ScheduleInputForm.module.scss";

/**
 * 立会希望日入力フォーム
 *
 * @for clients
 */
export const ScheduleInputForm: React.FC = () => {
	const { register, setValue, watch } =
		useFormContext<DealInspectionCandidateDateParam>();
	const inspectionCandidateDate1 = watch("inspectionCandidateDate1");
	const inspectionCandidateDate2 = watch("inspectionCandidateDate2");
	const inspectionCandidateDate3 = watch("inspectionCandidateDate3");
	return (
		<div>
			<FormControl label="立会希望日1" variant="horizontal">
				<div className={Styles.ScheduleInputArea}>
					<InputDatev2
						maxWidth="13rem"
						onChange={(date): void => {
							setValue("inspectionCandidateDate1", formatDate(date));
						}}
						value={toDate(inspectionCandidateDate1)}
					/>
					<Input
						placeholder="例）午前中"
						{...register("inspectionCandidateDateTime1")}
					/>
				</div>
			</FormControl>
			<FormControl label="立会希望日2" variant="horizontal">
				<div className={Styles.ScheduleInputArea}>
					<InputDatev2
						maxWidth="13rem"
						onChange={(date): void => {
							setValue("inspectionCandidateDate2", formatDate(date));
						}}
						value={toDate(inspectionCandidateDate2)}
					/>
					<Input
						placeholder="例）12時-14時"
						{...register("inspectionCandidateDateTime2")}
					/>
				</div>
			</FormControl>
			<FormControl label="立会希望日3" variant="horizontal">
				<div className={Styles.ScheduleInputArea}>
					<InputDatev2
						maxWidth="13rem"
						onChange={(date): void => {
							setValue("inspectionCandidateDate3", formatDate(date));
						}}
						value={toDate(inspectionCandidateDate3)}
					/>
					<Input
						placeholder="例）午後"
						{...register("inspectionCandidateDateTime3")}
					/>
				</div>
			</FormControl>
		</div>
	);
};
